module.exports = __webpack_public_path__ + "static/media/Mouth_2.0b5aae6e.jpg";